export default {"src":"/_next/static/media/viewers2.521a185c.svg","height":1599,"width":1440};